import base from '@/__vue2stone/service/wasaapi/v1/__base';
import store from '@/store';
import S_base from '@/service/api/v1/__base';

export default {
  async getRoleList(factoryId, params) {
    const res = S_base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'user_factory_role',
      params: params,
      pagination: true,
    });
    return res;
  },
  async getRoleContent(roleId) {
    const res = await S_base.show({
      url: `user_factory_role/${roleId}`,
    });
    return res;
  },
  async createRole(factoryId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      url: `factory/${factoryId}/user_factory_role`,
      data: _data,
    });
    return res;
  },
  async updateRole(roleId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      url: `user_factory_role/${roleId}`,
      data: _data,
    });
    return res;
  },
  async deleteRole(roleId) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
    };
    const res = await base.delete({
      url: `user_factory_role/${roleId}`,
      params: _params,
    });
    return res;
  },
  setRoleList(roleList) {
    const _roleList = JSON.parse(JSON.stringify(roleList));
    const result = _roleList.map((roleItem) => {
      return {
        id: roleItem.id,
        roleName: roleItem.name,
      };
    });
    return result;
  },
  setUserRoleService(roleList) {
    const _data = roleList.map((role) => {
      return {
        text: role.name,
        value: role.id,
        scope: role.scopes,
      };
    });
    return _data;
  },
  getCheckboxSelected(data, dataList) {
    //disable 角色已選取的scope(text)
    const _selectedScope = data;
    const _checkboxSelected = [];
    dataList.forEach((firstLayerItem) => {
      firstLayerItem.list.forEach((secondLayerItem) => {
        let _notSelected = [];
        secondLayerItem.id.forEach((itemId) => {
          if (!_selectedScope.find((selectedItem) => selectedItem === itemId)) {
            _notSelected.push(itemId);
          }
        });
        if (_notSelected.length === 0 || data.includes('wall-passer')) {
          _checkboxSelected.push(secondLayerItem.key);
        }
      });
    });
    return _checkboxSelected;
  },
  getRolesOfFactory(factoryId, list) {
    if (!list || list.length === 0) return [];
    return list.reduce((acc, item) => {
      if (item.factory && item.factory.id === factoryId) {
        acc.push(item.name);
      }
      return acc;
    }, []);
  },
  setMemberRoleList(roleList) {
    const _data = roleList.map((role) => {
      return {
        text: role.name,
        value: role.id,
        scope: role.scopes,
      };
    });
    return _data;
  },
  hasRole(data) {
    if ((data[0] && data[0].length > 0) || (data[1] && data[1].length > 0)) {
      return true;
    } else {
      return false;
    }
  },
  async indexByFile(params) {
    const res = S_base.index({
      parentName: 'factory',
      parentId: store.state.app.factory.id,
      modelName: 'user_factory_role/by_file/index',
      params,
    });
    return res;
  },
};
